// extracted by mini-css-extract-plugin
export default {"container":"WarningBanner_container__CBil3","accent":"WarningBanner_accent__nEp+r"};